import axiosClient from "./axiosClient";
import axiosClientNotTimeout from "./axiosClientNotTimeout";

const PREFIX_URL = "crm/tai-file";

const uploadFileApi = {
    uploadFile: (data) => {
        const url = `${PREFIX_URL}/uploadLocal`;
        return axiosClient.post(url, data);
    },
    uploadLocalConvert: (data) => {
        const url = `${PREFIX_URL}/uploadLocalConvert`;
        return axiosClientNotTimeout.post(url, data);
    },
    previewTempPdf: (file) => {
        const url = `${PREFIX_URL}/previewTempPdf`;
        return axiosClient.get(url, { params: { file }, responseType: 'blob', silent: true });
    },
    importUser: (data) => {
        const url = `${PREFIX_URL}/importUser`;
        return axiosClient.post(url, data);
    },
}

export default uploadFileApi;
